// 悬浮球相关
import { getUnionid } from '@/pages/Eating/api/index'
import { isWeixin } from '@/helpers'

const path = require('path')
const IS_PROD = process.env.NODE_ENV === 'production'
const IS_DEV = process.env.NODE_ENV === 'development'
const oneFloatNavigatorProdVersion = IS_PROD ? 'prod-0.0.1' : (IS_DEV ? 'test' : 'dev') // 升级版本请在此更改版本号
const STATIC_CDN = `https://${(IS_PROD ? '' : 't')}static.doctopia.com.cn/`
const commonCDN = (filepath) => {
  return STATIC_CDN + path.join('common', 'app-float-navigator', filepath)
}
const oneFloatNavigatorFilepath = `one-float-navigator.bmq.${oneFloatNavigatorProdVersion}.bundled.js`
const appFloatNavigatorEntry = commonCDN(oneFloatNavigatorFilepath)

export async function loadScript () {
  // 只在微信中显示悬浮球
  if (!isWeixin()) return false

  // 设置unionid
  try {
    const user = await getUnionid()
    window.unionid = user.data.data.unionid
  } catch (err) {
    console.warn('fetch unionid error', err)
  }

  const tags = document.createElement('script')
  tags.src = appFloatNavigatorEntry
  document.body.append(tags)
}
